import type { IconProps } from "../types";

export const Circle = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
  </svg>
);
